import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { EmailAttachment } from './models/attachment.interface';
import { mimeTypeIcons } from 'common/common/constants/mime-type-icons';

@Component({
  selector: 'app-genesys-email-attachments',
  templateUrl: './genesys-email-attachments.component.html',
  styleUrls: ['./genesys-email-attachments.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GenesysEmailAttachmentsComponent {
  @Input()
  attachments: EmailAttachment[];

  @Input()
  isEditable: boolean = false;

  @Output()
  public deleteAction: EventEmitter<EmailAttachment> = new EventEmitter();

  public getIconClass(contentType: string): string {
    return mimeTypeIcons[contentType] || mimeTypeIcons.default;
  }

  delete(attachment: EmailAttachment) {
    this.deleteAction.emit(attachment);
  }
}
